import { cn } from '@/lib/utils';

interface MobileSkeletonProps {
    className?: string;
}

export function MobileSkeleton({ className }: MobileSkeletonProps) {
    return (
        <div className={cn('mobile-skeleton', className)} />
    );
}

